import React, { useEffect, useState } from "react";
import { Button, Col, Row, Space } from "antd";
import { ThemeButton, ThemeFilterBtn } from "../Styles/Theme";
import {
  CaretRightOutlined,
  CheckCircleFilled,
  CheckCircleOutlined,
  LeftOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { Link, useNavigate, Navigate } from "react-router-dom";
import {
  ThemeFullTabs,
  ThemeNoSidebar,
  ThemeStudyWrapper,
} from "./SurveysStyle";
import StudyCover from "./StudyCover";
import Share from "./Share/Share";
import QuestionPreview from "./Create/QuestionPreview";
import { useSurveyPermissions } from "../../utils/permissions";

const SetUpStudy = () => {
  const navigate = useNavigate();
  
  // Permission check
  const { can } = useSurveyPermissions();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);
  return (
    <>
      <ThemeNoSidebar>
        <Row gutter={[16, 16]}>
          <Col xs={8} sm={10} md={14} lg={12} xl={12}>
            <div className="leftWrapper">
              <span>
                <ThemeFilterBtn
                  size="medium"
                  shape="circle"
                  icon={<LeftOutlined />}
                  className="noBackground mr-2"
                  onClick={() => navigate(-1)}
                />
              </span>
              Views on climate change & environmental
            </div>
          </Col>
          <Col xs={16} sm={14} md={10} lg={12} xl={12}>
            <div className="rightWrapper">
              <Space>
                <span className="draftSaved">
                  Draft Saved <CheckCircleFilled className="ml-1" />
                </span>
                <Link to="/surveys/study/set-up-study/preview">
                  <ThemeFilterBtn
                    className="mx-1 mx-sm-3"
                    size="large"
                    shape="circle"
                    iconPosition="end"
                    icon={<CaretRightOutlined />}
                  />
                </Link>
                {can('share') && (
                  isMobile ? (
                    <ThemeFilterBtn
                      onClick={() =>
                        navigate("/surveys/study/set-up-study/share/")
                      }
                      shape="circle"
                      size="large"
                      iconPosition="end"
                      icon={<img src="/images/send-icon.svg" alt="publish" />}
                    />
                  ) : (
                    <ThemeButton
                      onClick={() =>
                        navigate("/surveys/study/set-up-study/share/")
                      }
                      size="large"
                      iconPosition="end"
                      icon={<img src="/images/send-icon.svg" alt="publish" />}
                    >
                      Share with Participants
                    </ThemeButton>
                  )
                )}
              </Space>
            </div>
          </Col>
          <Col xs={24}>
            <StudyCover />
          </Col>
        </Row>
      </ThemeNoSidebar>
    </>
  );
};

export default SetUpStudy;
